import React, { Fragment } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image/withIEPolyfill"
import BackgroundImage from 'gatsby-background-image'
// import { graphql } from "gatsby"
// import loadable from '@loadable/component'
import browser from 'browser-detect'

// import { useStores } from "@hooks/useStores"
import YouTube from 'react-youtube'

import SEO from "@components/Seo"
import SEOArrows from "@components/Seo_arrows"
import Hero from "@components/blocks/IndexHero"
import Sct01 from "@components/blocks/IndexSct01"
import Sct02 from "@components/blocks/IndexSct02"
import Sct03 from "@components/blocks/IndexSct03"
import Sct04 from "@components/blocks/IndexSct04"
import Sct05 from "@components/blocks/IndexSct05"
import Sct06 from "@components/blocks/IndexSct06"
import Footer from "@components/blocks/GlobalFooter"
import Header from "@components/blocks/GlobalHeader"
import HeaderArrows from "@components/blocks/GlobalHeader_arrows"


import css from "@css/components/blocks/Index.module.styl"

// const ThreeJs = loadable( () => import('@three/Main.js'))

export default function Index()
{
	const q = useStaticQuery(graphql`
        query {
            bg: file(relativePath: { eq: "kv__img__bg@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 1440) {
                        ...GatsbyImageSharpFluid
                    }
                }
			}
		}
	`)

	// const { appStore } = useStores()
	const [browsed, setBrowsed] = React.useState()

	React.useEffect(()=>{
		if( !browsed ){
			setBrowsed(browser())
		}
		console.log(browsed)
	},[browsed])
	const _onReady = (event) => {
		event.target.mute()
		event.target.playVideo()
    }
    const _onEnd = (event) => {
		event.target.playVideo()
    }

    const videoOptions = {
        playerVars: { // https://developers.google.com/youtube/player_parameters
          autoplay: 1,
          controls: 0,
          rel: 0,
		  showinfo: 0,
		  loop: 1,
		  playsinline: 1,
        }
	}
	const isProd = process.env.GATSBY_PROD

	return pug`
		div#wrap
			if isProd === "0"
				Header
				SEO()
			else
				HeaderArrows
				SEOArrows()
			main(className=${css.container} id="main")
				Hero
				Sct01
				Sct02
				Sct03
				Sct04
				Sct05
				Sct06
			Footer

			if browsed && browsed.name === "ie"
				div(className=${css.bg})
					BackgroundImage(fluid=${q.bg.childImageSharp.fluid})
						div(className=${css.inner})
			else
				div(className="video-background")
					div(className="video-foreground")
						YouTube(
							videoId="-YVJU7805u0"
							opts=${videoOptions}
							className="video-iframe"
							onReady=${_onReady}
							onEnd=${_onEnd}
						)
	`
}